import { useEffect } from "react";
import { TelemetryClient } from "../telemetry/TelemetryClient";
import { useMsal } from "@azure/msal-react";
import { getTelemetryUserId } from "../telemetry/TelemetryUserIdentity";

/**
 * Hook to automatically set up telemetry user context with MSAL
 * Call this once in your App component to enable automatic user context in telemetry
 */
export const useTelemetryUserContext = () => {
    const { instance: msalInstance, accounts } = useMsal();

    useEffect(() => {
        // Set up the callback to get current user account
        TelemetryClient.setUserAccountCallback(() => {
            const activeAccount = msalInstance.getActiveAccount();
            const account = activeAccount || (accounts.length > 0 ? accounts[0] : null);

            if (account) {
                const userId = getTelemetryUserId(account);
                if (!userId) {
                    return null;
                }

                return {
                    userId,
                    tenantId: account.tenantId
                };
            }

            return null;
        });
    }, [msalInstance, accounts]);
};
